import { PageHero } from "@/components/public/Layout";
import { IMG } from "@/lib/images";

export function Privacy() {
  return (
    <div>
      <PageHero label="Legal" title="Privacy Policy" image={IMG.fineTable} />
      <section className="mx-auto max-w-3xl px-4 py-20 sm:px-6">
        <div className="space-y-6 text-inkmuted">
          <p>Mee2Momos respects your privacy. We collect the information you provide through our enquiry and contact forms — such as your name, contact details and requirements — solely to respond to your enquiry and deliver our hospitality services.</p>
          <p>We do not sell your personal information. Data is stored securely and accessed only by authorized members of our team through our internal DineOS platform.</p>
          <p>For any questions about your data, please contact us using the details on our Contact page.</p>
        </div>
      </section>
    </div>
  );
}

export function Terms() {
  return (
    <div>
      <PageHero label="Legal" title="Terms & Conditions" image={IMG.banquet} />
      <section className="mx-auto max-w-3xl px-4 py-20 sm:px-6">
        <div className="space-y-6 text-inkmuted">
          <p>By submitting an enquiry, you agree that Mee2Momos may contact you regarding your request. All catering, event and food-service engagements are subject to a separate written proposal and confirmation.</p>
          <p>Menu items, pricing and availability shown on this website are indicative and may vary by season, location and requirement. All food served is pure vegetarian &amp; Jain-Friendly.</p>
          <p>These terms may be updated from time to time. Continued use of the website constitutes acceptance of the latest terms.</p>
        </div>
      </section>
    </div>
  );
}
